import { AppInputNumber } from 'shared/UI/UIKit/InputNumber';
import { EducationLevel } from 'services/api/types';
import type { SubjectWithDifficulty } from 'services/api/subject-difficulties';
import type { AppTableColumn, AppTableSingleColumn } from 'shared/UI/UIKit/Table';

const generateColumns = (
  educationLevel: EducationLevel,
): AppTableSingleColumn<SubjectWithDifficulty>[] => {
  switch (educationLevel) {
    case EducationLevel.Noo:
      return Array.from({ length: 4 }, (_, index) => {
        const grade = index + 1;
        const diffKey = `diff${grade}`;
        return {
          key: diffKey,
          title: `${grade} класс`,
          dataIndex: [diffKey],
        };
      });
    case EducationLevel.Ooo:
      return Array.from({ length: 5 }, (_, index) => {
        const grade = index + 5;
        const diffKey = `diff${grade}`;
        return {
          key: diffKey,
          title: `${grade} класс`,
          dataIndex: [diffKey],
        };
      });
    case EducationLevel.Soo:
      return Array.from({ length: 2 }, (_, index) => {
        const grade = index + 10;
        const diffKey = `diff${grade}`;
        return {
          key: diffKey,
          title: `${grade} класс`,
          dataIndex: [diffKey],
        };
      });
    default:
      return [];
  }
};

export const getColumns = (
  handleDifficultyChange: (subjectId: number, field: string, value: number) => void,
  educationLevel: EducationLevel,
): AppTableColumn<SubjectWithDifficulty>[] => [
  {
    key: 'displayLabel',
    title: 'Наименование',
    dataIndex: ['subjectName'],
    minWidth: 800,
    ellipsis: true,
  },
  ...generateColumns(educationLevel).map((column) => ({
    ...column,
    width: 100,
    render: (value: number, record: SubjectWithDifficulty) => (
      <AppInputNumber
        defaultValue={value}
        min={1}
        precision={0}
        style={{ width: '100%' }}
        size="small"
        onWheel={(e) => e.currentTarget.blur()}
        onBlur={(e) => {
          const newValue = Number(e.target.value);
          if (!isNaN(newValue) && newValue >= 1 && newValue !== value) {
            handleDifficultyChange(record.subjectId, column.key, newValue);
          }
        }}
      />
    ),
  })),
];
